export { Batches as default } from '@/screens/batches/Batches'
